import { render, staticRenderFns } from "./tags-view.vue?vue&type=template&id=37cd3d6d&"
import script from "./tags-view.vue?vue&type=script&lang=js&"
export * from "./tags-view.vue?vue&type=script&lang=js&"
import style0 from "./tags-view.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports